// Path: ./src/hooks/useUnits.ts
import { useEffect, useCallback, useContext } from "react";
import { adminApiService } from "../utils/api";
import { GfUnit } from "@swagger/typescript-fetch-goflyer";
import { GoFlyerAdminContext } from "../contextApi/context";
import { setUnits } from "../contextApi/reducer";

export const useUnits = (autoFetch = true) => {
  const { state, dispatch } = useContext(GoFlyerAdminContext);

  const fetchUnits = useCallback(async (): Promise<GfUnit[] | undefined> => {
    try {
      const units =
        await adminApiService.getManyBaseGfUnitAdminControllerGfUnit();

      dispatch(setUnits(units.data));
      return units.data;
    } catch (error) {
      console.error("Error fetching units:", error);
      return undefined;
    }
  }, [dispatch]);

  useEffect(() => {
    if (autoFetch && !state.units) {
      fetchUnits();
    }
  }, [autoFetch, state.units, fetchUnits]);

  return { unitsList: state.units, fetchUnits };
};
